{
  "title": "Overview",
  "description": "Your servers, subscriptions and AI credits.",
  "greeting": "Hi {{name}}, here's {{org}} today.",
  "trial": {
    "title": "Your free trial",
    "daysLeft_one": "day left",
    "daysLeft_other": "days left",
    "noCard": "Your trial ends on {{date}}. Set up payment now so your servers keep going without a break; nothing is charged before the trial ends.",
    "withCard": "Payment is set up, and your paid subscription starts on its own on {{date}}. You can change the plan before then.",
    "progress": "Trial days used",
    "setUp": "Set up payment"
  },
  "stats": {
    "label": "Summary",
    "servers": "Servers",
    "allServers": "All servers",
    "accounts": "Hosting accounts",
    "ofCapacity": "of {{n}}",
    "accountsHint": "Across all activated servers",
    "renewal": "Next renewal",
    "firstCharge": "After the trial",
    "renewsOn": "On {{date}} for {{host}}",
    "afterTrial": "A month from {{date}}, excluding VAT",
    "noRenewal": "No upcoming renewal",
    "billing": "Billing",
    "credits": "AI credits left",
    "creditsLink": "Credit details"
  },
  "alerts": {
    "title": "Needs your attention",
    "none": "Nothing needs your attention.",
    "view": "View",
    "follow": "Follow",
    "grace": {
      "title": "{{host}} can't reach bPanel",
      "body": "Websites are running. If the server doesn't connect by {{date}}, adding new accounts stops until it does."
    },
    "restricted": {
      "title": "{{host}} has been offline for a while",
      "body": "Websites are running, but adding accounts is paused until the server reaches bPanel."
    },
    "pending": {
      "title": "{{host}} is waiting for its install",
      "body": "Install bPanel on the server with the activation key to activate the subscription.",
      "action": "Install steps"
    },
    "installing": {
      "title": "Installing bPanel on {{host}}",
      "body": "The subscription activates by itself at the last step."
    },
    "ending": {
      "title": "{{host}}'s subscription ends on {{date}}",
      "action": "Keep subscription"
    },
    "capacity": {
      "title": "{{host}} is at {{used}} of {{total}} accounts",
      "body": "Choose a bigger plan before it fills up.",
      "bodyHost": "Host allows extra accounts; each one over the capacity is added to the renewal.",
      "action": "Plan"
    },
    "update": {
      "title": "Version {{version}} is available for {{host}}"
    },
    "locked": {
      "title": "The control panel on {{host}} is locked",
      "body": "The subscription has ended. Websites, mail, databases and DNS keep running, and nothing is deleted. Renew to unlock the panel.",
      "action": "Renew now"
    },
    "unlocking": {
      "title": "{{host}} is renewed; the panel unlocks shortly",
      "body": "The control panel unlocks at the server's next check-in with bPanel, usually within minutes."
    },
    "firstPayment": {
      "title": "{{host}} is waiting for its first payment",
      "body": "Pay the first period to get the install steps and activation key.",
      "action": "Pay and install"
    }
  },
  "servers": {
    "title": "Your servers"
  },
  "quick": {
    "title": "Quick actions",
    "addServer": "Add server",
    "activate": "Activate with a code",
    "invite": "Invite a teammate",
    "ticket": "Open a ticket"
  },
  "activity": {
    "title": "Recent activity",
    "empty": "No activity yet."
  }
}
